module.exports = __webpack_public_path__ + "media/images/captive_portal/Settings-df129bc93b307f29109936448b835d29.svg";